import React from 'react';
import { TagIcon } from 'lucide-react';
import { BrandMark } from './BrandMark';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { images } from '../data/content';
export function Hero() {
  return <header className="bg-cream pb-16 pt-6 sm:pb-20 sm:pt-10" data-id="element-193" data-mp="9l357ep60g51">
      <div className="mx-auto max-w-5xl px-4 text-center sm:px-6" data-id="element-194" data-mp="4mi5rhhqm0hn">
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-195" data-mp="129h0hmovcycw">
          <BrandMark data-id="element-196" data-mp="1274mfkm8f854" />
          <span className="rounded-full border border-brand-200 bg-white px-3 py-1 text-xs font-bold uppercase tracking-wide text-brand-700" data-id="element-197" data-mp="xanra6gm7tij">
            7-Step CBCT Review System
          </span>
        </div>

        <h1 className="mx-auto mt-7 max-w-4xl font-serif text-[38px] font-extrabold leading-[1.05] text-ink sm:text-6xl lg:text-7xl" data-id="element-198" data-mp="nczsn5fw21v3">
          Review Any Implant CBCT in{' '}
          <em className="whitespace-nowrap font-black text-brand-600" data-id="element-199" data-mp="382fhvvzgliim">15 Minutes</em>
        </h1>
        <p className="mt-3 font-serif text-xl font-bold italic text-brand-800 sm:text-3xl" data-id="element-200" data-mp="3j8iw0w4jiat4">
          With a Step-by-Step Decision Map
        </p>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-xl" data-id="element-201" data-mp="3o6ar1z0hed1j">
          A structured clinical system that helps you review the key anatomical, diagnostic, and planning
          variables in the right order — so you can approach implant cases with a clearer process instead of
          staring at a CBCT wondering what you might be missing.
        </p>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] font-semibold text-ink sm:text-lg" data-id="element-202" data-mp="359syxghq0b4r">
          <span className="text-brand-700" data-id="element-203" data-mp="2qkwjuzh8xxun">6 Premium Volumes</span> +{' '}
          <span className="text-brand-700" data-id="element-204" data-mp="2viokchvyisag">5 Professional Bonuses</span> +{' '}
          <span className="text-brand-700" data-id="element-205" data-mp="2vglk7513bis0">40+ CBCT Review Tools & Checklists</span>
        </p>

        <img src={images.mockup} alt="CBCT Decision Map — 6 volumes, master map, checklists and worksheets" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-206" data-mp="2hlj8g19kaz7a" />

        <div id="hero-cta" className="mt-4" data-id="element-207" data-mp="s44itpsj1piy">
          <CtaButton label="I want the CBCT Decision Map™" note="Instant digital access · One-time payment of $27 USD · Lifetime access · 7-Day Guarantee" data-id="element-208" data-mp="nb1kl4ct1rwf" />
        </div>

        <Countdown data-id="element-209" data-mp="ddwzl7up42h7" />

        <div className="mx-auto mt-8 max-w-md rounded-2xl border border-brand-200 bg-white px-5 py-4" data-id="element-210" data-mp="deq7ic5e4y0x">
          <p className="flex items-center justify-center gap-2 text-sm font-extrabold uppercase tracking-wide text-alert" data-id="element-211" data-mp="1b0du65c1o1z9">
            <TagIcon className="h-4 w-4" aria-hidden="true" data-id="element-212" data-mp="15zztx9gopwbs" />
            Limited launch price
          </p>
          <p className="mt-1 text-sm text-muted" data-id="element-213" data-mp="x14o3yhjyo90">The regular price will be higher after the launch period.</p>
          <p className="mt-2 text-base font-semibold text-ink" data-id="element-214" data-mp="3lsp1x9cpsbcb">
            Get the complete CBCT Decision Map™ today for just{' '}
            <span className="font-extrabold text-cta-dark" data-id="element-215" data-mp="3hqahikted3ix">$27</span>.
          </p>
        </div>
      </div>
    </header>;
}